"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectionButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const ControlsMenuButton_1 = require("../ControlsMenuButton");
const bridge_1 = require("@completeanatomy/bridge");
const InfoBoxStateProvider_1 = require("../../providers/InfoBoxStateProvider");
const hooks_1 = require("../../hooks");
const i18n_1 = require("@completeanatomy/i18n");
const useMultiSelectState_1 = require("../../hooks/useMultiSelectState");
function MultiSelectionButton() {
    const { isActive } = (0, useMultiSelectState_1.useMultiSelectState)();
    const bridge = (0, bridge_1.useBridge)();
    let content = (0, i18n_1.Localized)(i18n_1.Strings.infoBox.menu.multiSelection);
    const [{ isExpandedItem }, dispatch] = (0, InfoBoxStateProvider_1.useInfoBoxStateContext)();
    if (isActive) {
        content = ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'MultiSelectionButton_Container', children: [(0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.Cross, width: 16, height: 16, "data-e2e": 'MultiSelectionButton_StyledIcon' }), (0, i18n_1.Localized)(i18n_1.Strings.infoBox.menu.multiSelectionExit)] }));
    }
    const handleClick = () => {
        if (isActive) {
            bridge === null || bridge === void 0 ? void 0 : bridge.disableMultipleSelection();
            isExpandedItem && dispatch((0, hooks_1.expandItem)(false));
        }
        else {
            bridge === null || bridge === void 0 ? void 0 : bridge.enableMultipleSelection();
        }
    };
    return ((0, jsx_runtime_1.jsx)(ControlsMenuButton_1.ControlsMenuButton, { selected: isActive, onClick: handleClick, "data-e2e": 'MultiSelectionButton_ControlsMenuButton', children: content }));
}
exports.MultiSelectionButton = MultiSelectionButton;
const Container = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  margin-right: 7px;
  margin-left: 7px;
`;
